{
  "savedViews.browse.cappedCount": "First {{count}} retained",
  "savedViews.browse.default": "Default view",
  "savedViews.browse.definitionSummary": "{{filters}} filters · {{columns}} columns",
  "savedViews.browse.emptyDescription": "Save a filter from Tasks, Projects, Life, Notes, Knowledge, Periods or Journal to run it here.",
  "savedViews.browse.emptyTitle": "No saved views yet",
  "savedViews.browse.fields.display_label": "Label",
  "savedViews.browse.fields.entry_kind": "Kind",
  "savedViews.browse.fields.item_type": "Type",
  "savedViews.browse.fields.occurred_at": "Occurred",
  "savedViews.browse.fields.start_date": "Start",
  "savedViews.browse.fields.end_date": "End",
  "savedViews.browse.fields.updated": "Updated",
  "savedViews.browse.legacyDefinition": "Migration required",
  "savedViews.browse.lede": "Run your saved filters across their owning collections from one place.",
  "savedViews.browse.listTitle": "Views",
  "savedViews.browse.loadError": "Saved views could not be loaded",
  "savedViews.browse.loadMore": "Load more results",
  "savedViews.browse.matchCount": "{{count}} matches",
  "savedViews.browse.no": "No",
  "savedViews.browse.noResults": "No matching records",
  "savedViews.browse.noResultsDescription": "The view ran successfully, but no active record matches its filters.",
  "savedViews.browse.noSelection": "Choose a saved view",
  "savedViews.browse.openRecord": "Open record",
  "savedViews.browse.pinned": "Pinned view",
  "savedViews.browse.resultsDescription": "Live results from {{surface}}",
  "savedViews.browse.resultsError": "This saved view could not be run",
  "savedViews.browse.resultsTitle": "Results",
  "savedViews.browse.selectDescription": "Select a view to run its validated filters.",
  "savedViews.browse.title": "Saved views",
  "savedViews.browse.unknownSurface": "Collection",
  "savedViews.browse.viewCount": "{{count}} views",
  "savedViews.browse.yes": "Yes",
  "savedViews.publicLinks.actionErrorDescription": "The public link action could not be completed.",
  "savedViews.publicLinks.active": "Active",
  "savedViews.publicLinks.activeCount": "Active links: {{count}}",
  "savedViews.publicLinks.cancel": "Cancel",
  "savedViews.publicLinks.confirmRevoke": "Revoke link",
  "savedViews.publicLinks.copied": "Public link copied.",
  "savedViews.publicLinks.copy": "Copy link",
  "savedViews.publicLinks.copyError": "The public link could not be copied.",
  "savedViews.publicLinks.copyLabel": "Copy {{kind}} link expiring {{date}}",
  "savedViews.publicLinks.create": "Create link",
  "savedViews.publicLinks.createForm": "Create a public link",
  "savedViews.publicLinks.created": "A new public link was created.",
  "savedViews.publicLinks.credentialWarning": "Anyone with this link can read the bounded result until it expires or you revoke it.",
  "savedViews.publicLinks.description": "Create, inspect and revoke anonymous read-only links for the selected view.",
  "savedViews.publicLinks.emptyDescription": "Choose a lifetime and create the first anonymous read-only link.",
  "savedViews.publicLinks.emptyTitle": "No public links for this view",
  "savedViews.publicLinks.enable": "Allow public links",
  "savedViews.publicLinks.enableDescription": "This only permits explicitly created, expiring links; it does not publish the view by itself.",
  "savedViews.publicLinks.enableTitle": "Make this view shareable first",
  "savedViews.publicLinks.expired": "Inactive · expired",
  "savedViews.publicLinks.expiresAt": "Expires {{date}}",
  "savedViews.publicLinks.expiry": "Lifetime",
  "savedViews.publicLinks.expiry.1": "1 hour",
  "savedViews.publicLinks.expiry.24": "24 hours",
  "savedViews.publicLinks.expiry.168": "7 days",
  "savedViews.publicLinks.expiry.720": "30 days",
  "savedViews.publicLinks.kind": "Public format",
  "savedViews.publicLinks.kindReport": "Report",
  "savedViews.publicLinks.kindView": "Saved view",
  "savedViews.publicLinks.listLabel": "Public links for the selected view",
  "savedViews.publicLinks.loadError": "Public links could not be loaded",
  "savedViews.publicLinks.open": "Open",
  "savedViews.publicLinks.openLabel": "Open {{kind}} link expiring {{date}}",
  "savedViews.publicLinks.pdf": "PDF",
  "savedViews.publicLinks.pdfLabel": "Open PDF for {{kind}} link expiring {{date}}",
  "savedViews.publicLinks.print": "Print view",
  "savedViews.publicLinks.printLabel": "Open printable {{kind}} link expiring {{date}}",
  "savedViews.publicLinks.private": "Private",
  "savedViews.publicLinks.privateInactive": "Inactive · view is private",
  "savedViews.publicLinks.revoke": "Revoke",
  "savedViews.publicLinks.revokeConflict": "This link changed elsewhere. The latest status has been loaded; review it before trying again.",
  "savedViews.publicLinks.revokeLabel": "Revoke {{kind}} link expiring {{date}}",
  "savedViews.publicLinks.revokePrompt": "This URL will stop working immediately. Revoke it?",
  "savedViews.publicLinks.revoked": "Inactive · revoked",
  "savedViews.publicLinks.revokedSuccess": "The public link was revoked.",
  "savedViews.publicLinks.shareableEnabled": "Public links are now allowed for this view.",
  "savedViews.publicLinks.title": "Public links",
  "savedViews.publicLinks.visibilityConflict": "The view changed elsewhere. Its latest state is being loaded; review it before enabling public links.",
  "savedViews.surfaces.journal": "Journal",
  "savedViews.surfaces.knowledge": "Knowledge",
  "savedViews.surfaces.lifeRecords": "Life records",
  "savedViews.surfaces.notes": "Notes",
  "savedViews.surfaces.periods": "Periods"
}
